import type { StateCreator } from 'zustand';

export type LoadingSlice = {
  loading: { id: string }[];
  setLoading: (loading: { id: string }) => void;
  removeLoading: (id: string) => void;
  clearLoading: () => void;
};

export const createLoadingSlice: StateCreator<
  LoadingSlice,
  [],
  [],
  LoadingSlice
> = (set) => ({
  loading: [],
  setLoading: (loading: { id: string }) =>
    set((state) => ({
      loading: [...state.loading, loading],
    })),
  removeLoading: (id: string) =>
    set((state) => ({
      loading: state.loading.filter((loading) => loading.id !== id),
    })),
  clearLoading: () => set({ loading: [] }),
});
